import {
	get,
	post,
	put,
	deleteRequest,
	deleteRequestV2
} from '../../api/usersModule/httpClient';
import { useEffect, useState } from 'react';
import { CDBModal } from 'cdbreact';
import { ModalModules } from '../../Components/Modals/ModalModules';
import { LargeCard } from '../Cards/LargeCard';
import swal from 'sweetalert';
import { useDebounce } from '../../hooks/useDebounce';
import Swal from 'sweetalert2';

const usersheaders = ['Id', 'Modulo', 'Descripción', 'Usuario'];
const defaultFormData = {
	ModuleID: '',
	ModuleName: '',
	ModuleDescription: '',
};

export const CrudModules = ({ userName, permissions }) => {
	const [data, setData] = useState([]);
	const [state, setState] = useState({ modal1: false });
	const [page, setPage] = useState(1);
	const [pressedButton, setPressedButton] = useState('');
	const [action, setAction] = useState('');
	const [changePage, setChangePage] = useState(false);
	const [totalItems, setTotalItems] = useState(0);
	const [formData, setFormData] = useState(defaultFormData);
	const [loading, setLoading] = useState(true);
	const [itemsPerPage, setItemsPerPage] = useState(5);

	/* -------------------------------- BUSQUEDA -------------------------------- */
	const [search, setSearch] = useState('');
	const debouncedSearch = useDebounce(search, 500);

	const getData = async (search, statusPage) => {
		setLoading(true);
		const data = await get(`/modules?page=${statusPage}&search=${search}&limit=${itemsPerPage}`);
		setTotalItems(data.pagination.totalItems);
		setData(data.items);
		setLoading(false);
	};

	const getModule = async (id) => {
		const data = await get(`/modules?moduleID=${id}`);
		setFormData({
			ModuleID: data.items[0].ModuleID,
			ModuleName: data.items[0].ModuleName,
			ModuleDescription: data.items[0].ModuleDescription,
		});
	};

	const convertDataToArray = () => {
		try {
			return data.map((item) => [
				item.ModuleID,
				item.ModuleName.charAt(0).toUpperCase() + item.ModuleName.slice(1).toLowerCase(),
				item.ModuleDescription.charAt(0).toUpperCase() + item.ModuleDescription.slice(1).toLowerCase(),
				item.User.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' '),
			]);
		} catch (error) {
			console.error(error);
			return [];
		}
	};	

	const toggle = (nr) => () => {
		let modalNumber = 'modal' + nr;
		setState({
			...state,
			[modalNumber]: !state[modalNumber],
		});
	};

	const handleChange = (e) => {
		setFormData({ ...formData, [e.target.id]: e.target.value });
	};

	const handleSubmit = async () => {

		const formattedUserName = userName ? userName.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ') : '';

		const info = {
			ModuleID: formData.ModuleID,
			ModuleName: formData.ModuleName.charAt(0).toUpperCase() + formData.ModuleName.slice(1).toLowerCase(),
			ModuleDescription: formData.ModuleDescription.charAt(0).toUpperCase() + formData.ModuleDescription.slice(1),
			user: formattedUserName,
		};
	
		Swal.fire({
			title: `${action === "create" ? 'Creando' : 'Actualizando'} Módulo`,
			text: 'Por favor, espere...',
			icon: 'info',
			allowOutsideClick: false,
			showCancelButton: false,
			showConfirmButton: false,
			willOpen: () => {
				Swal.showLoading();
			},
		});
	
		if (action === 'create') {
			delete info.ModuleID;
			await post('/modules', info);
	
			Swal.close();
	
			getData('', 1);
		} else {
			put('/modules', info);
	
			Swal.close();
		}
	};

	const deleteModule = async () => {
		const body = {
			moduleID: formData.ModuleID,
		};

		const confirmDelete = await Swal.fire({
			title: 'Confirmar Eliminación del Módulo',
			text: 'Esta acción eliminará de manera permanente el Módulo seleccionado, así como cualquier dato relacionado. ¿Está seguro de que desea proceder?',
			icon: 'warning',
			showCancelButton: true,
			confirmButtonColor: '#146284',
			cancelButtonColor: '#EF4444',
			confirmButtonText: 'Sí, eliminar',
			cancelButtonText: 'Cancelar',
		});

		if (confirmDelete.isConfirmed) {
			await deleteRequestV2('/modules', body, true);

			Swal.close();
			toggle(6)();
			getData('', 1);
		}
	};

	useEffect(() => {
		if (!changePage) {
			getData('', page);
		}else {
			setChangePage(false)
		}
    // eslint-disable-next-line react-hooks/exhaustive-deps
	}, [page]);

	useEffect(() => {
		getData(debouncedSearch, 1);
		setChangePage(true);
    	setPage(1)
	}, [debouncedSearch]);

	useEffect(() => {
		getData(debouncedSearch, 1);
		setChangePage(true);
    	setPage(1)
	}, [itemsPerPage]);

	useEffect(() => {}, [formData]);

	useEffect(() => {
		switch (pressedButton.split(',')[0]) {
			case 'create':
				if (permissions['Crear']) {
					setAction('create');
					setFormData(defaultFormData);
					toggle(6)();
				} else {
					swal({
						title: 'Error',
						text: 'No tiene permisos para crear modulos',
						icon: 'error',
						buttons: ['', 'Aceptar'],
					});
				}
				break;
			case 'edit':
				if (permissions['Editar']) {
					setAction('edit');
					getModule(pressedButton.split(',')[1]);
					toggle(6)();
				} else {
					swal({
						title: 'Error',
						text: 'No tiene permisos para editar modulos',
						icon: 'error',
						buttons: ['', 'Aceptar'],
					});
				}
				break;
			case 'delete':
				if (permissions['Eliminar']) {
					deleteModule();
				} else {
					swal({
						title: 'Error',
						text: 'No tiene permisos para eliminar modulos',
						icon: 'error',
						buttons: ['', 'Aceptar'],
					});
				}
				break;
			case 'refresh':
				setData(['']);
				getData('', page);
				break;
			case 'closeModal':
				toggle(6)();
				break;
			case 'submitModal':
				handleSubmit();
				toggle(6)();
				break;
			default:
				break;
		}
		setPressedButton('');
    // eslint-disable-next-line react-hooks/exhaustive-deps
	}, [pressedButton]);

	return (
		<>
			<LargeCard
				name='Módulos'
				headers={usersheaders}
				loading={loading}
				data={convertDataToArray()}
				totalItems={totalItems}
				setPage={setPage}
				page={page}
				setChangePage={setChangePage}
				setPressedButton={setPressedButton}
				customTable={false}
				setSearch={setSearch}
				cState={true}
				itemsPerPage={itemsPerPage}
        		setItemsPerPage={setItemsPerPage}
			/>

			<CDBModal isOpen={state.modal6} toggle={toggle(6)}>
				<ModalModules
					action={action}
					setPressedButton={setPressedButton}
					formData={formData}
					handleChange={handleChange}
				/>
			</CDBModal>
		</>
	);
};
